export const UPDATE_EXPANDED_MENU_ID =
  'header/components/Menu/UPDATE_EXPANDED_MENU_ID';
export const UPDATE_SUB_MENU = 'header/components/Menu/UPDATE_SUB_MENU';
